var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BuyBase",
    {
      staticClass: "tap-free",
      attrs: {
        title: _vm.getConstants("PRICING_NEW_COMMON_FREE"),
        actions: _vm.getConstants("PRICING_NEW_TAP_USE"),
        type: "free"
      },
      on: { viewDetail: _vm.viewDetail }
    },
    [
      _c(
        "div",
        { attrs: { slot: "limit" }, slot: "limit" },
        [
          _c("p", [
            _vm._v(_vm._s(_vm.getConstants("PRICING_NEW_TAP_FREE_UPLOAD")))
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(_vm._s(_vm.getConstants("PRICING_NEW_TAP_FREE_DOWNLOAD")))
          ]),
          _vm._v(" "),
          _c("UploadTip", {
            attrs: {
              text: _vm.getConstants("PRICING_NEW_TAP_FREE_LIMIT"),
              content: _vm.getConstants("PRICING_NEW_TAP_FREE_UPLOAD_TIPS")
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }